import { Component, OnInit } from '@angular/core';
import { BsModalService, ModalOptions } from 'ngx-bootstrap/modal';
import { PlayerClassSelectorComponent } from 'src/app/components/player-class-selector/player-class-selector.component';
import { DataStoreService } from 'src/app/data-store.service';
import { AttributeStore, InventoryItem, Player } from 'src/app/models/models';

@Component({
  selector: 'app-inventory-management',
  templateUrl: './inventory-management.component.html',
  styleUrls: ['./inventory-management.component.scss']
})
export class InventoryManagementComponent implements OnInit {

  filter_slot: number | undefined;

  player: Player | undefined;
  inventory: Record<string, InventoryItem> = {};

  enhancedinventory: {
    name?: string, tier: number, quantity: number, slot: number | undefined, diff: AttributeStore | undefined
  }[] = []


  equipment: {
    item?: {
      name: string,
      tier: number,
      quantity: number,
      diff: AttributeStore | undefined
    }
    slot: number
  }[] = [];

  constructor(public store: DataStoreService, private modalService: BsModalService) { }

  ngOnInit(): void {
    this.store.Load();
    this.store.UpdateStats();

    var slots = 1;
    this.store.items.forEach(c => {
      this.inventory[c.name] = c;
      if (c.equip_slot && c.equip_slot > slots)
        slots = c.equip_slot
    });

    for (var x = 1; x <= slots; x++)
      this.equipment.push({ slot: x, item: undefined });

    if (this.store.players.length > 0) {
      this.PlayerLoaded(this.store.players[0])
    }

  }

  SetFilter(slot: number | undefined) {
    this.filter_slot = slot;
    this.PlayerLoaded(this.player);
  }

  Sort() {

    var temp = this.store.inventory.filter(x => x.name !== undefined && x.quantity >= 0);

    temp.sort((a, b) => {

      if (a.name) {
        var str = a.name.toLowerCase().localeCompare((b.name || '').toLowerCase());

        if (str != 0)
          return str
      }

      if (a.tier > b.tier)
        return -1;
      else if (b.tier > a.tier)
        return 1;

      return 0;
    });

    this.store.inventory = temp;
    this.store.Save();

    if (this.player)
      this.PlayerLoaded(this.player);
  }

  PlayerLoaded(p: Player | undefined, clear_filter: boolean = false) {

    if (clear_filter)
      this.filter_slot = undefined;



    if (p) {
      this.player = p;

      this.equipment = this.equipment.map(x => {
        var item = p.equipment.filter(e => this.inventory[e.name].equip_slot === x.slot);
        return {
          slot: x.slot,
          item: item.length > 0 ? { name: item[0].name, tier: item[0].tier, quantity: 1, diff: this.inventory[item[0].name].effect_equip } : undefined
        }
      });



      var temp = this.store.inventory.map(itemCell => {

        var dif: AttributeStore | undefined = undefined;
        if (itemCell.name) {



          var itemCellDetails = this.inventory[itemCell.name];

          if (itemCellDetails.equip_slot && this.player) {
            var equipped = this.player.equipment.find(e => this.inventory[e.name].equip_slot === itemCellDetails.equip_slot);
            if (equipped) {
              var equippedDetails = this.inventory[equipped.name].effect_equip;

              if (equippedDetails) {

                dif = {
                  attack: ((itemCellDetails.effect_equip?.attack || 0) * this.store.TierMultiplier(itemCell.tier)) - ((equippedDetails.attack || 0) * this.store.TierMultiplier(equipped.tier)),
                  defense: ((itemCellDetails.effect_equip?.defense || 0) * this.store.TierMultiplier(itemCell.tier)) - ((equippedDetails.defense || 0) * this.store.TierMultiplier(equipped.tier)),
                  vitality: ((itemCellDetails.effect_equip?.vitality || 0) * this.store.TierMultiplier(itemCell.tier)) - ((equippedDetails.vitality || 0) * this.store.TierMultiplier(equipped.tier)),
                  stamina: ((itemCellDetails.effect_equip?.stamina || 0) * this.store.TierMultiplier(itemCell.tier)) - ((equippedDetails.stamina || 0) * this.store.TierMultiplier(equipped.tier)),
                }
              }
            }
            else {
              dif = itemCellDetails.effect_equip
            }
          }
          return { name: itemCell.name, tier: itemCell.tier, slot: itemCellDetails.equip_slot, quantity: itemCell.quantity, diff: dif }
        }


        return { name: undefined, tier: itemCell.tier, slot: undefined, quantity: itemCell.quantity, diff: dif }

      }).filter(f => !this.filter_slot || this.filter_slot === f.slot);

      // temp.sort((a, b) => {

      //   var str = a.name.toLowerCase().localeCompare(b.name.toLowerCase());

      //   if (str != 0)
      //     return str

      //   if (a.tier > b.tier)
      //     return -1;
      //   else if (b.tier > a.tier)
      //     return 1;

      //   return 0;
      // });

      this.enhancedinventory = temp;
    }
  }

  GetPrice(enhanceditem: { name?: string; tier: number; quantity: number; }): number {
    var item = this.store.inventory.find(x => x.name == enhanceditem.name && x.tier === enhanceditem.tier);
    if (item && item.name)
      return this.inventory[item.name].price * (item.tier > 1 ? (item.tier * 5 - 5) : 1);
    return 0;
  }

  Sell(enhanceditem: { name?: string; tier: number; quantity: number; }) {
    var item = this.store.inventory.find(x => x.name == enhanceditem.name && x.tier === enhanceditem.tier);
    if (item && item.name) {
      this.store.gold += this.GetPrice(enhanceditem);
      this.DecrementInventory(item.name, enhanceditem.tier, 1);
      this.store.Save();
      if (this.player) {
        this.PlayerLoaded(this.player);
      }
    }

  }

  MergeAll() {
    var currentTier = 1;
    var maxTier = this.store.inventory.reduce((acc, c) => c.tier > acc ? c.tier : acc, 1) + 1;

    while (currentTier <= maxTier) {
      var items = this.store.inventory.filter(i => i.tier === currentTier && i.name && i.quantity > 2 && this.inventory[i.name].equip_slot);
      items.forEach(i => {
        while (this.Merge(i)) { };
      });

      currentTier++;
    }
    this.PlayerLoaded(this.player);
  }

  Merge(enhanceditem: { name?: string; tier: number; quantity: number; }): boolean {
    var item = this.store.inventory.find(x => x.name === enhanceditem.name && x.tier === enhanceditem.tier);
    if (item && item.name && item.quantity >= enhanceditem.tier + 1) {

      var name = item.name;
      this.DecrementInventory(name, enhanceditem.tier, enhanceditem.tier + 1);
      this.store.IncrementInventory(name, enhanceditem.tier + 1);

      this.PlayerLoaded(this.player);

      this.store.Save();

      return item.quantity >= item.tier * 2;
    }

    return false;
  }

  DecrementInventory(name: string, tier: number, quantity: number) {
    var item = this.store.inventory.find(x => x.name === name && x.tier === tier);
    if (item) {
      if (item.quantity > quantity)
        item.quantity -= quantity;
      else {
        item.quantity = 0;
        item.name = undefined;
      }
    }
  }

  Equip(enhanceditem: { name?: string; tier: number; quantity: number; }) {
    var item = this.store.inventory.find(x => x.name === enhanceditem.name && x.tier === enhanceditem.tier);

    if (this.player && item && item.name) {

      var desiredInfo = this.inventory[item.name]
      var current = this.player.equipment.filter(x => this.inventory[x.name].equip_slot === desiredInfo.equip_slot);

      if (item.quantity === 1) {
        item.quantity = 0;
        item.name = undefined;
      }
      else
        item.quantity--;

      if (current.length > 0) {
        this.player.equipment = this.player.equipment.filter(x => x != current[0]);

        this.store.IncrementInventory(current[0].name, current[0].tier);
      }

      this.player.equipment.push({ name: enhanceditem.name || '', tier: enhanceditem.tier, slot: desiredInfo.equip_slot || 0 })
      this.store.UpdateStats();
      this.store.Save();
      this.PlayerLoaded(this.player);

    }
  }

  Use(enhanceditem: { name?: string; tier: number; quantity: number; }) {
    var item = this.store.inventory.find(x => x.name === enhanceditem.name && x.tier === enhanceditem.tier);
    if (item && item.name && this.player) {
      var desiredInfo = this.inventory[item.name];


      if (item.quantity > 1) {
        item.quantity--;
      }
      else {
        item.quantity = 0;
        item.name = undefined;
      }



      if (desiredInfo.effect_consumed) {
        this.player.attributes.attack = (this.player.attributes.attack || 0) + (desiredInfo.effect_consumed.attack || 0) * this.store.TierMultiplier(enhanceditem.tier);
        this.player.attributes.defense = (this.player.attributes.defense || 0) + (desiredInfo.effect_consumed.defense || 0) * this.store.TierMultiplier(enhanceditem.tier);
        this.player.attributes.vitality = (this.player.attributes.vitality || 0) + (desiredInfo.effect_consumed.vitality || 0) * this.store.TierMultiplier(enhanceditem.tier);
        this.player.attributes.stamina = (this.player.attributes.stamina || 0) + (desiredInfo.effect_consumed.stamina || 0) * this.store.TierMultiplier(enhanceditem.tier);
        this.player.health += (desiredInfo.effect_consumed.health || 0) * this.store.TierMultiplier(enhanceditem.tier);
        this.player.energy += (desiredInfo.effect_consumed.energy || 0) * this.store.TierMultiplier(enhanceditem.tier);
        this.player.exp += (desiredInfo.effect_consumed.exp || 0) * this.store.TierMultiplier(enhanceditem.tier);

      }
      //this.store.inventory.sort((a, b) => a.name.localeCompare(b.name));
      this.store.Save();
      if (this.player) {
        this.PlayerLoaded(this.player);
      }
    }
  }


}
